/**
 * ACF `video_style`: "portrait" | "landscape" (also accepts vertical / horizontal).
 * @param {unknown} value
 * @returns {'portrait' | 'landscape'}
 */
export function normalizeCourseVideoStyle(value) {
    if (value == null || value === "") return "landscape";
    const v = String(value).toLowerCase().trim();
    if (v === "portrait" || v === "vertical") return "portrait";
    if (v === "landscape" || v === "horizontal") return "landscape";
    return "landscape";
}

/**
 * Responsive box for 16:9 (landscape) or 9:16 (portrait) video embeds.
 * @param {'portrait' | 'landscape'} mode
 * @returns {import('react').CSSProperties}
 */
export function getCourseVideoFrameStyle(mode) {
    if (mode === "portrait") {
        /* Portrait sizing: .portraitHero (intro) / .portraitAccordion in courseVideoFrame.module.scss */
        return {};
    }
    return {
        position: "relative",
        width: "100%",
        aspectRatio: "16 / 9",
    };
}
